/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/13/21
 * Copyright All Rights Reserved
 */
import { FETCH_INVENTORIES_RESPONSE } from 'constants/actionTypes';

const defaultState = [];

const allIds = (state = defaultState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case FETCH_INVENTORIES_RESPONSE:
      return error ? state : payload.map(inventory => inventory.uuid);
    default:
      return state;
  }
};

export default allIds;



// WEBPACK FOOTER //
// ./js/reducers/entities/inventories/allIds.js